export const brandHandler = {
    pathPattern: '/brands/:brandId',
    toWeb: ({ brandId }) => ({ path: `/brands/${brandId}` }),
    meta: {
        title: 'Brand dashboard root',
        description: 'Opens the brand root in the operator dashboard.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [{ name: 'brandId', in: 'path', required: true }],
        example: { params: { brandId: 'BXqExampleBrandId' } },
    },
};
//# sourceMappingURL=brand.js.map